// Wallet DTOs
export interface CreateWalletDto {
    name: string;
    description: string;
    schoolId: string;
    feeCategoryId?: string;
    isMainWallet: boolean;
}

export interface WalletDto {
    id: string;
    name: string;
    description: string;
    schoolId: string;
    isMainWallet: boolean;
    feeCategoryId?: string;
    feeCategoryName?: string;
    balance: number;
    createdAt: string;
}

export interface TransferFundsDto {
    fromWalletId: string;
    toWalletId: string;
    amount: number;
    description: string;
    initiatedByUserId: string;
}

// Wallet service functions that use axios from useAxios hook
export const walletService = {
    async getSchoolWallets(axiosClient: any, schoolId: string) {
        const response = await axiosClient.get(`/api/wallet/school/${schoolId}`);
        return response.data;
    },

    async getWalletBalance(axiosClient: any, walletId: string) {
        const response = await axiosClient.get(`/api/wallet/${walletId}/balance`);
        return response.data;
    },

    async createWallet(axiosClient: any, data: CreateWalletDto) {
        const response = await axiosClient.post(`/api/wallet`, data);
        return response.data;
    },

    async transferFunds(axiosClient: any, data: TransferFundsDto) {
        const response = await axiosClient.post(`/api/wallet/transfer`, data);
        return response.data;
    }
};
